import { React, useRef, useState } from "react";
import { Col, Form, Row, Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { useHistory } from "react-router";
import Image from "react-bootstrap/Image";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import EmptyItemView from "../EmptyItemView";
import * as setOffSelectors from "../../selectors/set-off";
import {
  getSetOffAccrueInterest,
  getSetOffAccrueInterestFullText,
  getSetOffOutstandingAmountFullText,
  getSetOffTotalOutstandingAmount,
  getSetOffTotalOutstandingAmountFullText,
  getSetOffTotalOutstandingBalance,
  getSetOffTotalOutstandingBalanceFullText,
} from "../../selectors/set-off";
import clsx from "clsx";
import CustomPriceSpan from "../CustomPriceSpan";
import CurrencyInput from "react-currency-input-field";
import Helper from "../../utils/Helper";
import { Tooltip as ReactTooltip } from "react-tooltip";

function CustomSetOffTable({ data, setPartAmt, partAmt, creditValue, debitValue, selectedCurrency }) {
  const [checkedItems, setCheckedItems] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const tooltipsRef = useRef();
  const handleCheckboxChange = (index, total) => {
    setCheckedItems((prevCheckedItems) => {
      const newCheckedItems = { ...prevCheckedItems, [index]: !prevCheckedItems[index] };
      const isChecked = newCheckedItems[index];

      let shouldFillNumber = total;
      const diff = Number(creditValue - debitValue);
      if (diff < 0 && total > 0) {
        if (Math.abs(diff) > Math.abs(total)) {
          shouldFillNumber = total;
        } else {
          shouldFillNumber = diff;
        }
      } else if (diff > 0 && total < 0) {
        if (Math.abs(diff) > Math.abs(total)) {
          shouldFillNumber = total;
        } else {
          shouldFillNumber = diff;
        }
      }

      setPartAmt((prevPartAmt) => ({
        ...prevPartAmt,
        [index]: {
          // total: isChecked ? Math.abs(total).toFixed(2) : "0",
          total: isChecked ? Math.abs(shouldFillNumber) : 0,
          negative: total < 0,
        },
      }));

      return newCheckedItems;
    });
  };
  return (
    <div className={"responsive-table-border"}>
      <Table responsive="lg">
        <thead>
        <tr className={"custom-table-setoff-styled"}>
          {/*===== For "CheckBox" ===== */}
          {/*<th style={{ width: "30px" }}>-</th>*/}
          <th style={{width: "30px"}}>
            {/*<Form.Check*/}
            {/*    checked={selectAllChecked}*/}
            {/*    className="custom-setoff-table-checkbox"*/}
            {/*    onChange={handleSelectAllChange}*/}
            {/*/>*/}
          </th>
          <th style={{width: 100}}>Date</th>
          <th style={{width: 120}}>Reference No</th>
          <th style={{width: 100}}>Stock Code</th>
          <th style={{width: 120}}>Stock Name</th>
          <th style={{width: 100}}>Amount</th>
          <th style={{width: 100}}>Accrued Interest</th>
          <th style={{width: 100}}>Total Amount</th>
          <th style={{width: 100}}>Balance Amount</th>
          {/*===== End for For "CheckBox" ===== */}
          {/*===== For "Part Amt" ===== */}
          <th style={{width: "200px"}}>Selected Amount</th>
          {/*===== End for "Part Amt" ===== */}
        </tr>
        </thead>
        <tbody>
        {!_.isEmpty(data) ? (
            _.map(data, (setOff, index) => {
              const refNo = setOffSelectors.getSetOffContractReference(setOff);
              const date = setOffSelectors.getSetOffTransactionDate(setOff);
              const stockCode = setOffSelectors.getSetOffStockCode(setOff);
              const stockName = setOffSelectors.getSetOffStockName(setOff);
              const balAmount = setOffSelectors.getSetOffOutstandingAmountFullText(setOff);
              const accrueInterest = setOffSelectors.getSetOffAccrueInterestFullText(setOff);
              const total = setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
              const totalFullText = setOffSelectors.getSetOffTotalOutstandingBalanceFullText(setOff);
              const totalOutstandingAmount = setOffSelectors.getSetOffTotalOutstandingAmountFullText(setOff);

              return (
                  <tr
                      key={index}
                      className={clsx({
                        ["disabled"]: Math.abs(total) <= 0,
                      })}
                      onClick={(e) => {
                        if (Math.abs(total) <= 0) {
                          tooltipsRef.current?.open({
                            position: {
                              x: e.clientX,
                              y: e.clientY,
                            },
                            place: "bottom",
                            content: "The balance is less than 0.",
                          });
                        }
                      }}
                      onMouseEnter={(e) => {
                        if (Math.abs(total) <= 0) {
                          tooltipsRef.current?.open({
                            position: {
                              x: e.clientX,
                              y: e.clientY,
                            },
                            place: "bottom",
                            content: "The balance is less than 0.",
                          });
                        }
                      }}
                      onMouseLeave={(e) => {
                        tooltipsRef.current?.close();
                      }}
                  >
                    <td style={{width: "30px"}}>
                      <Form.Check
                          checked={_.get(partAmt, [index, "total"], 0) > 0}
                          className="custom-setoff-table-checkbox"
                          onChange={() => handleCheckboxChange(index, total)}
                      />
                    </td>
                    <td style={{width: 100}}>{date}</td>
                    <td style={{width: 120}}>{refNo}</td>
                    <td style={{width: 100}}>{stockCode ?? '-'}</td>
                    <td style={{width: 150}}>{stockName ?? '-'}</td>
                    <td style={{width: 100}}>{balAmount}</td>
                    <td style={{width: 100}}>{accrueInterest}</td>
                    <td style={{width: 100}}>{totalOutstandingAmount}</td>
                    <td style={{width: 100}}>{totalFullText}</td>
                    <td style={{width: 200}}>
                      <CurrencyInput
                          id="input-example"
                          name="input-name"
                          disabled={Math.abs(total) <= 0}
                          placeholder="Please enter a number"
                          prefix={Math.floor(total) > 0 ? "+" : "-"}
                          className={clsx("custom-setoff-table-input")}
                          value={_.get(partAmt, [index, "total"], 0)}
                          decimalScale={2}
                          decimalSeparator="."
                          groupSeparator=","
                          max={`${Math.abs(total)}`}
                          min={0}
                          onValueChange={(value, name, values) => {
                            setPartAmt((prev) => {
                              let newValue = value;

                              if (Math.abs(newValue) > Math.abs(total)) {
                                newValue = Math.abs(total)
                              }

                              if (newValue === undefined) {
                                newValue = "0";
                              }
                              // if (Math.abs(value) > Math.abs(total)) {
                              //   return {
                              //     ...prev,
                              //     [index]: {
                              //       total: Math.abs(total),
                              //       negative: total < 0,
                              //     },
                              //   };
                              // }
                              // if (value === undefined) {
                              //   return {
                              //     ...prev,
                              //     [index]: {
                              //       total: 0,
                              //       negative: total < 0,
                              //     },
                              //   };
                              // }
                              // if (_.last(value) === ".") {
                              //   return {
                              //     ...prev,
                              //     [index]: {
                              //       total: value,
                              //       negative: total < 0,
                              //     },
                              //   };
                              // }
                              // const abs = _.floor(value, 2) * 100;
                              if (newValue && (newValue.toString().substring(0, 1) === '-' || newValue.toString().substring(0, 1) === '+')) {
                                newValue = newValue.slice(1)
                              }
                              return {
                                ...prev,
                                [index]: {
                                  total: newValue,
                                  negative: total < 0,
                                },
                              };
                            });
                          }}
                      />
                    </td>
                  </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={10}>
                <EmptyItemView />
              </td>
            </tr>
          )}
        </tbody>
        <tfoot className="setoff-table-footer">
        <tr>
          <td style={{width: 30, borderBottom: 0}}></td>
          <td style={{width: 120, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 150, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <th style={{width: 100, borderBottom: 0}}>Credit Amount</th>
          <th style={{width: 200}}>
            <div className="d-flex justify-content-between">
                <span>
                  {" "}
                  {selectedCurrency?.text} <CustomPriceSpan value={creditValue}></CustomPriceSpan>
                </span>
            </div>
          </th>
        </tr>
        <tr>
          <td style={{width: 30, borderBottom: 0}}></td>
          <td style={{width: 120, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 150, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <th style={{width: 100, borderBottom: 0}}>Debit Amount</th>
          <th style={{width: 200}}>
            <div className="d-flex justify-content-between">
                <span>
                  {selectedCurrency?.text} <CustomPriceSpan value={debitValue}></CustomPriceSpan>
                </span>
            </div>
          </th>
        </tr>
        <tr>
          <td style={{width: 30, borderBottom: 0}}></td>
          <td style={{width: 120, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 150, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <th style={{width: 100, borderBottom: 0}}>Balance Amount</th>
          <th style={{width: 200}}>
            <div className="d-flex justify-content-between">
                <span>
                  {" "}
                  {selectedCurrency?.text} <CustomPriceSpan value={(creditValue - debitValue) * -1}></CustomPriceSpan>
                </span>
            </div>
          </th>
        </tr>
        <tr>
          <td style={{width: 30, borderBottom: 0}}></td>
          <td style={{width: 120, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 150, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <td style={{width: 100, borderBottom: 0}}></td>
          <th style={{width: 100, borderBottom: 0}}></th>
          <th style={{width: 200}}>
            <div
                className={clsx("d-flex justify-content-between", {
                  ["positive-number"]: _.isEqual(
                      Helper.formattedPrice(debitValue),
                      Helper.formattedPrice(creditValue),
                  ),
                  ["negative-number"]: !_.isEqual(
                      Helper.formattedPrice(debitValue),
                      Helper.formattedPrice(creditValue),
                  ),
                })}
            >
              {_.isEqual(Helper.formattedPrice(debitValue), Helper.formattedPrice(creditValue))
                  ? "The enter amount is valid"
                  : "Amount doesn't tally"}
            </div>
          </th>
        </tr>
        </tfoot>
      </Table>
      <ReactTooltip ref={tooltipsRef} className="tooltip-info" variant="info"></ReactTooltip>
    </div>
  );
}

export default CustomSetOffTable;
